// A draft the customer already paid by link (gap #8, at Review): before the job is called off, what
// was paid moves to the customer's credit (payments.keepAsCredit), from where it can be refunded or
// used on another invoice. The same confirm sheet as the Money tab.

import { useState } from 'react';
import { KeepAsCredit } from '../history/MoneyActions.tsx';
import type { InvoiceSummary } from './review-model.ts';

export function KeepCredit({ invoice, onDone }: { invoice: InvoiceSummary; onDone: () => void }) {
  const [open, setOpen] = useState(false);
  const [said, setSaid] = useState<string | null>(null);
  const paid = invoice.totalCents - invoice.balanceCents;
  // once kept, the draft owes again and the button goes; what happened stays said
  if (!said && (invoice.status !== 'draft' || paid <= 0)) return null;
  return (
    <div className="keep-credit">
      {said ? (
        <p className="notice ok" role="status">
          {said}
        </p>
      ) : (
        <div className="row">
          <button className="btn" onClick={() => setOpen(true)}>
            Keep the payment as credit…
          </button>
        </div>
      )}
      {open && (
        <KeepAsCredit
          invoice={{ id: invoice.id, number: invoice.number, paidCents: paid }}
          onClose={() => setOpen(false)}
          onDone={(m) => {
            setOpen(false);
            setSaid(m);
            onDone();
          }}
        />
      )}
    </div>
  );
}
